export const UPDATE_ALL_DATA = "UPDATE_ALL_DATA";
export const RESET_STORE = "RESET_EDIT_JOURNALIST_STORE";
